import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Tyre Location'}
      url={'tyre-location'}
      queryKey="tyre-locations"
      title={'Tyre Location'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
